// extracted by mini-css-extract-plugin
export default {"addToAgendaBtn":"ShowtimeModale_addToAgendaBtn__VX0AM","cancelBtn":"ShowtimeModale_cancelBtn__0ShmR"};